import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { VerificationAgencyClientService } from '../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService';
import { ColumnSortOption, SortDirections } from '../../../Component/Model/Dto/ColumnSortOption';
import { VAClientData, VAClientSearchRequest } from '../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { defaultObject } from '../../../Helpers/typescriptHelper';
import { UserAtom } from '../../../State/user.Atom';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';
import { VAClientTableMapper } from './VerificationAgencyClientTableMapper';
import { VerificationAgencyClientTable } from './VerificationAgencyTable';
import { ImportExportButtonsDialog } from '../../Common/ImportAndExport/ImportExportButtonsDialog';
import { DataImportType } from '../../../Component/Model/Enum/BEE123Enums';
import config from "../../../config";

export const VerificationAgencyClientsPage = () => {

    const [company, setCompany] = useRecoilState(VerificationCompanyAtom);
    const [VAClientData, setVAClientData] = useState<VAClientData[]>(defaultObject);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);

    const resetCompany = useResetRecoilState(VerificationCompanyAtom);
    const user = useRecoilValue(UserAtom);
    const history = useHistory();

    const VAClientSearchRequest: VAClientSearchRequest = {
        Draw: 2,
        PageNumber: pageNumber,
        PageSize: entriesPerPage.defaultValue!,
        ColumnSortOptions: columnSortOptions,
        SearchValue: searchValue,
        RegistrationId: user.registrationId
    };

    const VAClientDataSearch = async () => {

        if (user.registrationId != null && user.registrationId !== "") {
            setIsLoading(true);
            try {
                const vaClientSearchResult = await VerificationAgencyClientService.VAClientSearch(VAClientSearchRequest);
                setVAClientData(vaClientSearchResult.data.results); // Set the API data, not the table data
                setFilteredItemsCount(vaClientSearchResult.data.filteredItemsCount);
                setTotalItemsCount(vaClientSearchResult.data.totalItemsCount);
            } catch (error) {
                setIsLoading(false);
                setFilteredItemsCount(1);
                setTotalItemsCount(1);
            } finally {
                setIsLoading(false);
            }
        }
    }

    const handleRouteToCompany = (companyId: number, name:string, registrationNumber:string, vatNumber:string) => {
        setCompany({...company, vaClientId: companyId , company:name, registrationNumber: registrationNumber, vatNumber: vatNumber});
        history.push(`/company/details/company`);
    }

    useEffect(() => {
        resetCompany();
        VAClientDataSearch();
    }, [entriesPerPage, pageNumber, searchValue, columnSortOptions, user.registrationId]); // eslint-disable-line react-hooks/exhaustive-deps

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (searchValue: string) => {
        setSearchValue(searchValue);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions([sortOption]);
        setPageNumber(1);
    }

    const tableData = VAClientTableMapper(VAClientData, handleRouteToCompany); //Map the API data into the table

    return (
        <div className='center'>
            <Grid container>
                <Grid item xs={12}>
                    <VerificationAgencyClientTable
                        results={tableData!}
                        entriesPerPage={entriesPerPage}
                        pageNumber={pageNumber}
                        filteredItemsCount={filteredItemsCount}
                        totalItemsCount={totalItemsCount}
                        entriesPerPageChanged={entriesPerPageChanged}
                        pageNumberChanged={pageNumberChanged}
                        searchValueChanged={searchValueChanged}
                        isLoading={isLoading}
                        columnSortingChanged={columnSortingChanged}
                    />
                    {config.enable_VA_client_contacts_import === 'true' &&
                    <ImportExportButtonsDialog
                        type={"VerificationAgencyClient"}
                        typeId={DataImportType.VerificationAgencyClient}
                        uploadType={DataImportType[DataImportType.VerificationAgencyClient]}
                        reloadTable={VAClientDataSearch}
                        parameters={[]}
                        controlsEnabled={true}
                        showHelpfileDownload={true}
                        importBus={true}
                        coreExportEnabled={true}
                        coreImportEnabled={true}
                        disableExport={true}
                    />}
                </Grid>
            </Grid>
        </div>
    )
}

